var internet = {};
module['exports'] = internet;
internet.domain_suffix = require("./domain_suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nb_NO/internet/index.js
 ** module id = 846
 ** module chunks = 0
 **/